import { render, staticRenderFns } from "./NotificationView.vue?vue&type=template&id=271d3df5&"
import script from "./NotificationView.vue?vue&type=script&lang=ts&"
export * from "./NotificationView.vue?vue&type=script&lang=ts&"
import style0 from "./NotificationView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports